import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: provided => ({
    ...provided,
    ':focus-within': {
      boxShadow:
        'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 5px var(--falcon-soft-primary) !important;'
    }
  })
};

const CustomSelect = props => {
  return <Select styles={customStyles} {...props} />;
};

export default CustomSelect;
